import { Link } from "react-router-dom";

const Type = (props) => {
    return(
        <Link to={`/pokedex/`+props.type}>
            <div className="typelink">
                    {props.type}
            </div>
        </Link>
    )
}

export default Type;